<template>
    <DefaultPanel class="spese-panel">
        <template>
            <small v-if="description" class="mb-2 d-block">{{description}}</small>
            <div v-if="showNotInterested" class="d-flex justify-content-between mb-1">
                <div class="d-flex justify-content-between">
                    <a href="javascript:void(0)">
                        <img v-if="isSelectedEmpty" src="../../../assets/images/svg/orange/icone_btn-acceso.svg" height="24px" @click="onSelect(null)"/>
                        <img v-else src="../../../assets/images/svg/orange/icone_btn-spento.svg" height="24px" @click="onSelect(null)"/>
                    </a>
                    <div class="pl-1">
                        <small class="default-bold">Non sono interessato</small>
                    </div>
                </div>
            </div>
            <div v-for="(item, index) in list" :class="index === list.length-1? '' : 'mb-1'" :key="index">
                <div class="d-md-flex justify-content-md-between mb-2 mb-md-0">
                    <div class="d-flex justify-content-md-between pr-2">
                        <a href="javascript:void(0)">
                            <img v-if="isSelectedItem(item)" src="../../../assets/images/svg/orange/icone_btn-acceso.svg" height="24px"/>
                            <img v-else src="../../../assets/images/svg/orange/icone_btn-spento.svg" height="24px" @click="onSelect(item)"/>
                        </a>
                        <div class="pl-1">
                            <small class="default-bold">{{item.extraData.nome}}</small>
                        </div>
                        <div :class="`icon-circle-border-blue mr-1 ${isMobile? 'adjustIconMobile' : 'adjustIcon'}`" v-if="item.extraData.descrizione">
                            <a href="javascript:void(0)" @click="onDetail(item)">
                                <img src="../../../assets/images/svg/blue/icone_dettagli.svg" width="16px"/>
                            </a>
                        </div>
                    </div>
                    <div :class="isMobile? 'd-flex justify-content-between border my-1 px-2' : 'd-flex justify-content-between'" style="height: 22px">
                        <div class="border-right nowrap" style="min-width: 110px">
                            <div class="d-flex justify-content-between mr-2">
                                <div>
                                    <small class="text-uppercase">a persona</small>
                                </div>
                                <div>
                                    <small class="cursive">{{formatMoney(item.prezzo.venditaTotaleEuro)}} &euro;</small>
                                </div>
                            </div>
                        </div>
                        <div class="border-right nowrap" style="min-width: 90px">
                            <div class="d-flex justify-content-between mx-2">
                                <div>
                                    <small class="text-uppercase">quantità</small>
                                </div>
                                <div>
                                    <small class="cursive">{{item.prezzo.quantita}}</small>
                                </div>
                            </div>
                        </div>
                        <div class="nowrap" style="min-width: 70px">
                            <div class="d-flex justify-content-between ml-2">
                                <div>
                                    <small class="text-uppercase">TOT</small>
                                </div>
                                <div>
                                    <small class="cursive">{{formatMoney(item.prezzo.venditaTotaleEuro * item.prezzo.quantita)}} &euro;</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border my-2 p-2" v-if="reloaded && item.extraData.descrizione && item.show">
                    <small>
                        <pre>{{item.extraData.descrizione}}</pre>
                    </small>
                </div>
            </div>
        </template>
    </DefaultPanel>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import DefaultPanel from '../../templates/DefaultPanel'
import {formatMoney} from '../../../utils/formatter'
import MobileDetector from '../../common/MobileDetector'

export default {
  name: 'SpesePanel',
  mixins: [MobileDetector],
  components: {DefaultPanel},
  props: {
    index: Number,
    value: Array
  },
  data () {
    return {
      reloaded: false
    }
  },
  computed: {
    description () {
      return this.list[0].extraData.descrizione
    },
    showNotInterested () {
      const flagAgenzia = this.list[0].flagAgenzia
      return flagAgenzia < 0 || flagAgenzia === undefined
    },
    isSelectedEmpty () {
      return this.value.every(item => item.selected === false)
    },
    list () {
      return this.value.map(item => {
        return {...item, show: false}
      })
    }
  },
  methods: {
    ...mapGetters(['getSpeseAccessorie']),
    ...mapActions(['selectSpesa']),
    formatMoney,
    onSelect (obj) {
      const payload = {index: this.index, itemId: obj ? obj.itemId : 0}
      this.selectSpesa(payload)
      this.$emit('select', payload)
    },
    isSelectedItem (item) {
      return item.selected
    },
    onDetail (item) {
      this.reloaded = false
      item.show = !item.show
      this.$nextTick(() => {
        this.reloaded = true
      })
    }
  }
}
</script>
<style scoped>
    .adjustIcon {
        position: relative;
        top: -3px;
        left: 5px;
        padding: 2px 4px;
    }
    .adjustIconMobile {
        position: relative;
        top: -3px;
        left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/front/components/widgets/common/SpesePanel.vue